module.exports = __webpack_public_path__ + "static/media/pdf-icon-with-text.e84a661d.svg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/pdf-icon-with-text.svg
// module id = 1811
// module chunks = 1